import { useState, useEffect } from 'react';

const useMobileDetector = () => {
  const [isMobile, setIsMobile] = useState<boolean>(window.innerWidth < 768); // Adjust the threshold as needed

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768); // Adjust the threshold as needed
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []); // Empty dependency array ensures this effect runs only once on mount

  return isMobile;
};

export default useMobileDetector;
